import { Box, Button, Typography, Modal, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import ModeTwoToneIcon from "@mui/icons-material/ModeTwoTone";
import apiEndPointsConfig from "../../../../services/apiEndPoints";
import axiosInstance from "../../../../services/axiosInstance";

const TicketComment = ({ ticket }) => {
  const { id } = useParams();
  const token = localStorage.getItem("token");
  const agentId = localStorage.getItem("agentId");
  const [comments, setComments] = useState([]);
  const [open, setOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [currentComment, setCurrentComment] = useState(null);
  const [commentId, setCommentId] = useState("");

  console.log(commentId, "commentId");

  useEffect(() => {
    getComment();
  }, []);

  const getComment = async () => {
    try {
      const res = await axiosInstance.get(
        `${apiEndPointsConfig.getAllComments}/${id}`
      );
      setComments(res.data.data);
    } catch (error) {
      console.error("Error fetching comments:", error);
    }
  };

  const deleteComment = async (commentId) => {
    try {
      const res = await axiosInstance.delete(
        `${apiEndPointsConfig.deleteComment}/${commentId}`
      );
      getComment();
    } catch (error) {
      console.error("Error fetching comments:", error);
    }
  };

  const handleModalOpen = () => {
    setEditMode(false);
    setOpen(true);
    setCurrentComment(null);
  };

  const handleModalClose = () => {
    setOpen(false);
    formik.resetForm();
  };

  const handleEditClick = (comment) => {
    setCommentId(comment._id);
    setEditMode(true);
    setCurrentComment(comment);
    setOpen(true);
    formik.setValues({ comment: comment.comments });
  };

  const formik = useFormik({
    initialValues: {
      comment: "",
    },
    validationSchema: Yup.object({
      comment: Yup.string()
        .required("Comment is required")
        .min(5, "Comment must be at least 5 characters long"),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        if (editMode && currentComment) {
          await axiosInstance.put(
            `${apiEndPointsConfig.editComment}/${commentId}`,
            { comments: values.comment }
          );
          resetForm();
          getComment();
        } else {
          // Add new comment
          const data = {
            ticketId: id,
            comments: values.comment,
            userCommentBy: "agent",
          };
          await axiosInstance.post(`${apiEndPointsConfig.addComment}`, data);
        }
        resetForm();
        getComment();
        handleModalClose();
      } catch (error) {
        console.error("Error submitting comment:", error);
      }
    },
  });

  return (
    <Box
      sx={{
        bgcolor: "white",
        p: 2,
        borderRadius: "8px",
        mt: 4,
        border: "1px solid lightgrey",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography>Comments</Typography>
        <Button
          sx={{ textTransform: "capitalize" }}
          variant="contained"
          onClick={handleModalOpen}
        >
          Add Comment
        </Button>
      </Box>
      <Box
        sx={{
          borderTop: "1px solid #e3e3e3",
          mt: 2,
        }}
      />
      {comments?.map((e, i) => (
        <Box
          key={i}
          sx={{
            mt: 2,
          }}
        >
          <Typography
            sx={{
              fontSize: "0.9rem",
              color: "black",
            }}
          >
            User Name: {e?.userCommentBy}
          </Typography>
          <Typography
            sx={{
              fontSize: "1rem",
              color: "grey",
            }}
          >
            {e?.comments}
          </Typography>

          {e.userCommentBy == "agent" && (
            <Box>
              <Button onClick={() => deleteComment(e._id)}>
                <DeleteIcon
                  sx={{
                    fontSize: 20,
                    color: "#707070",
                  }}
                />
              </Button>
              <Button onClick={() => handleEditClick(e)}>
                <ModeTwoToneIcon
                  sx={{
                    fontSize: 20,
                    color: "#707070",
                  }}
                />
              </Button>
            </Box>
          )}
        </Box>
      ))}

      {/* Modal for Adding/Editing Comment */}
      <Modal open={open} onClose={handleModalClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "white",
            p: 3,
            borderRadius: 2,
            boxShadow: 24,
            minWidth: "400px",
          }}
        >
          <Typography variant="h6" sx={{ mb: 2 }}>
            {editMode ? "Edit Comment" : "Add Comment"}
          </Typography>
          <form onSubmit={formik.handleSubmit}>
            <TextField
              fullWidth
              id="comment"
              name="comment"
              label="Comment"
              variant="outlined"
              value={formik.values.comment}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.comment && Boolean(formik.errors.comment)}
              helperText={formik.touched.comment && formik.errors.comment}
              sx={{ mb: 2 }}
            />
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Button onClick={handleModalClose} sx={{ mr: 1 }}>
                Cancel
              </Button>
              <Button type="submit" variant="contained">
                {editMode ? "Update" : "Submit"}
              </Button>
            </Box>
          </form>
        </Box>
      </Modal>
    </Box>
  );
};

export default TicketComment;
